import { ReactNode } from "react";
import { Argument } from "classnames/dedupe";
import { TThemeVariant } from "../ThemeProvider/ThemeContext";
/** Type of button */
export type TSelectButtonType = "default" | "flat" | "rounded" | "clear";

/** Calculated position values */
export type RectPos = {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  width?: string;
  height?: string;
};

export enum DropdownPosition {
  TOP = "top",
  RIGHT = "right",
  BOTTOM = "bottom",
  LEFT = "left",
}

export enum DropdownAlignment {
  START = "start",
  MIDDLE = "middle",
  END = "end",
  FIT = "fit",
  STRETCH = "stretch",
}

export enum DropdownToggleStrategy {
  CLICK = "click",
  HOVER = "hover",
  NONE = "none",
}

export enum DropdownDrawingStrategy {
  JS = "JS",
  CSS = "CSS",
}

export interface IDropdownProps {
  classes?: {
    button?: Argument;
    wrapper?: Argument;
  };
  /** Unique identifier, will be applied to element in DOM */
  id?: string;
  /** Name of animation, will be applied as css class for `CSSTransition` component */
  animation?: string;
  /** Force open / close */
  opened?: boolean;
  /** Can be opened or not */
  disabled?: boolean;
  /** Type of button variant */
  variant?: TSelectButtonType;
  /** Main theme / color palette */
  theme?: TThemeVariant;
  /** Button's main theme / color palette */
  buttonTheme?: TThemeVariant;
  /** Toggle to a flyout at the bottom of the screen on mobile resolutions */
  toggleToFlyoutOnMobile?: boolean;
  /** Initial position (will be changed if element doesn't fit the window) */
  position?: DropdownPosition;
  /** Initial alignment (will be changed if element doesn't fit the window) */
  alignment?: DropdownAlignment;
  /** Main element/button that will toggle the dropdown */
  dropdownButton?: ReactNode;
  /** Open by click or hover, etc. */
  toggleStrategy?: DropdownToggleStrategy;
  /** Draw dropdown by CSS means or by JS calculations */
  drawingStrategy?: DropdownDrawingStrategy;
  children?: ReactNode;
  /** Fires when dropdown opens/closes */
  onChange?(newOpened: boolean): void;
  /** Fires when main element/button is clicked */
  onClick?(): void;
  /** Fires when main element/button or dropdown is hovered */
  onMouseEnter?(): void;
  /** Fires when main element/button and dropdown lost hover */
  onMouseLeave?(): void;
}

export type TDirectionDescription = "e" | "s" | "b" | "t" | "";
